// extracted by mini-css-extract-plugin
export default {"chat_header_close_icon":"styles_chat_header_close_icon__2oc4z"};